import Constant from "@/common/constant/Constant";
import { isEditField } from "../../handler/CommonHandler";

export const checkIsCancelTabs = (argsAll) => {
    switch (argsAll.settingSelectItem) {
        case Constant.SETTING_SELECT_ITEM_TAG_FIELD.MASTER_KNOWLEDGE:
            // check master knowledge
            if (
                argsAll.currentUpdateField?.relatedMasterForm !== argsAll.masterKnowledge.formMaster ||
                argsAll.currentUpdateField?.settingAutoAdd !== argsAll.masterKnowledge.isAutoAddData
            ) {
                break;
            }

            // check update item
            let isUpdateItem = false;
            for (const newItem of argsAll.masterKnowledge.listItem) {
                let currentItem = argsAll.currentUpdateField?.structure?.listItem?.find(
                    o => o.itemId === newItem.itemId
                );
                if (
                    newItem.isActive !== currentItem?.isActive ||
                    newItem.order !== currentItem?.order
                ) {
                    isUpdateItem = true;
                    break;
                }
            }

            if (!isUpdateItem) {
                return false;
            }
            break;
        case Constant.SETTING_SELECT_ITEM_TAG_FIELD.AUTO_FILL:
            // check master knowledge
            if (
                argsAll.currentUpdateField?.relatedMasterForm !==
                argsAll.autoFillMasterField.formMaster ||
                    argsAll.currentUpdateField?.settingAutoAdd !==
                    argsAll.autoFillMasterField.isAutoAddData ||
                    argsAll.currentUpdateField?.relatedField !== argsAll.autoFillMasterField.relatedField
            ) {
                break;
            }

            // check update item
            let isUpdateAutoFillItem = false;
            for (const newItem of argsAll.autoFillMasterField.listItem) {
                let currentItem = argsAll.currentUpdateField?.structure?.listItem?.find(
                    o => o.itemId === newItem.itemId
                );
                if (
                    newItem.isActive !== currentItem?.isActive ||
                    newItem.order !== currentItem?.order
                ) {
                    isUpdateAutoFillItem = true;
                    break;
                }
            }

            if (!isUpdateAutoFillItem) {
                return false;
            }
            break;
        default:
            // if not change data then go to screen parent
            if (argsAll.isDisableBtnSave && argsAll.defaultData?.itemList?.length === argsAll.itemList?.length) {
                return false;
            }
            break;
    }
    return true;
};

export const isHiddenEditBtn = (argsCommon) => {
    if (
        [Constant.FORM_MANAGEMENT_SCREEN.EDIT_FORM].includes(argsCommon.parentPanelScreen) &&
        !isEditField(argsCommon.currentUpdateField, argsCommon)
    ) {
        return true;
    }
    return false;
};